import React from 'react';
import useLazyLoad from 'hooks/useLazyLoad';

import './banner.css';
import { StyledBanner } from './styled';

interface BannerProps {
  img?: string
  alt?: string
  legacyBlock?: string
}

export default function Banner({img, alt, legacyBlock}: BannerProps): React.JSX.Element | null {
  useLazyLoad();

  if (img) {
    return <img src={img} alt={alt} className="lazy" />;
  } else if(legacyBlock) {
    return <StyledBanner className="module" dangerouslySetInnerHTML={{__html: `${legacyBlock}`}} />;
  }
  return null;
}
